import React, { useState, useEffect, useCallback } from "react";
import { StorageConfig, HotelConfig } from "../../../Model/StorageConfig";
import { EFootprint } from "../../../Model/PlateType";
import { EModuleType } from "../../../Model/EModuleType";
import { useTypedSelector } from "../../../redux/reducers/RootReducer";
import { getModulesByType } from "../../../redux/reducers/ModuleReducer";
import { getStorageConfig } from "../../../redux/reducers/StorageConfigReducer";
import { getModuleState } from "../../../redux/reducers/ModuleStateReducer";
import "./StorageListGroup.css";
import MtiButton from "../../Buttons/MtiButton";
import StorageApi from "../../../api/StorageApi";
import { EPsrState } from "../../../Model/ModuleState";
import ToolsApi from "../../../api/ToolsApi";
import { EAutoCalibrationResult } from "../../../Model/EAutoCalibrationResult";
import RadioButton from "../../Buttons/RadioButton";

const getHotels = (storageConfig: StorageConfig, label: string | undefined) => {
  let hotels = [];
  for (let i = 0; i < storageConfig.hotels.length; i++) {
    hotels.push({
      id: i,
      name: `${label ?? 'hotel'}-${
        storageConfig.hotels[i].number
      }`,
      display: label == "Imager" ? label : `Hotel ${EFootprint[storageConfig.hotels[i].footprint]} ${storageConfig.hotels[i].number}`,
    });
  }
  return hotels;
};

///selected index should not in disable slot
const initialSelectedindex = (hotelConfig: HotelConfig) => {
  if (hotelConfig === undefined) return -1;
  if (hotelConfig.disabledSlots !== null) {
    let disabledSlotsList: number[] | null =
      hotelConfig.disabledSlots == null
        ? null
        : hotelConfig.disabledSlots?.split(",").map(Number);
    for (let i = 0; i < hotelConfig.capacity; i++) {
      let slotIndex: number = i + 1;
      if (disabledSlotsList?.includes(slotIndex) == false) return i; // first id of not disable slot
    }
    return -1; //all slot disable, no index selected
  }
  return 0; //no disable slot
};

type Props = {
  moduleType: EModuleType;
  isPsrBusy: boolean;
  setIsPsrBusy: (busy: boolean) => void;
  style?: React.CSSProperties;
  selectedHotelIndex: number;
  setSelectedHotelIndex: (index: number, moduleType: EModuleType) => void;
  setImagerId: (id: string) => void;
};

export default function StorageListGroup({
  isPsrBusy,
  setIsPsrBusy,
  style = {},
  selectedHotelIndex,
  setSelectedHotelIndex,
  moduleType,
  setImagerId,
}: Props) {
  // selectedSlotIndex =-1 --> not initialized
  const [selectedSlotIndex, setSelectedSlotIndex] = useState(-1);

  const loadportStorageModule = useTypedSelector(
    (state) => getModulesByType(state)[EModuleType.LOADPORT][0]
  );

  const chamberStorageModule =  useTypedSelector(
    (state) => getModulesByType(state)[EModuleType.CHAMBER][0]
  );

  const imagerStorageModule = useTypedSelector(
    (state) => getModulesByType(state)[EModuleType.IMAGER][0]
  );
  const psrModule = useTypedSelector(
    (state) => getModulesByType(state)[EModuleType.PSR][0]
  );
  const loadportStorageConfig = useTypedSelector((state) =>
    getStorageConfig(state, loadportStorageModule.identifier)
  );
  const chamberStorageConfig = useTypedSelector((state) =>
    getStorageConfig(state, chamberStorageModule.identifier)
  );
  const imagerStorageConfig = useTypedSelector((state) =>
    getStorageConfig(state, imagerStorageModule.identifier)
  );

  const psrModuleState = useTypedSelector(
    (state) => getModuleState(state, psrModule.identifier).psr
  );
  if (psrModuleState == null) {
    throw new Error("Psr State is null");
  }

  useEffect(() => {
    setIsPsrBusy(psrModuleState.state === EPsrState.Busy);
  }, [loadportStorageConfig, psrModuleState]);

  useEffect(() => {
    let selectedSlot = initialSelectedindex(
      loadportStorageConfig.hotels[selectedHotelIndex]
    );
    setSelectedSlotIndex(selectedSlot);
  }, [loadportStorageConfig, selectedHotelIndex]);

  const loadportHotels = getHotels(loadportStorageConfig, 'LoadPort');
  const storageHotels = getHotels(chamberStorageConfig, 'Chamber');
  const imagerHotels = getHotels(imagerStorageConfig, 'Imager')

  return (
    <div className="store-retrieve-wrapper">
      <div className="tools-store-retrieve-container" style={style}>
        <div className="tools-store-retrieve-title">
          <div>Load Port</div>
        </div>
        <div className="radio-wrapper">
          {loadportHotels.map((hotel, i) => (
            <RadioButton 
              id={hotel.display + "-" + i}
              name={hotel.name}
              onChange={() => setSelectedHotelIndex(i, EModuleType.LOADPORT)}
              checked={moduleType === EModuleType.LOADPORT && selectedHotelIndex === i}
              color="alternate"
              label={hotel.display}
              style={{fontSize: '14px'}}
            />
          ))}
        </div>
        <div className="store-retrieve-list">
          <div className="title">Imager</div>
        <div className="radio-wrapper">
          {imagerHotels.map((hotel, i) => (
            <RadioButton 
              id={hotel.display + "-" + i}
              name={hotel.name}
              onChange={() => {
                setImagerId(hotel.id.toString())
                setSelectedHotelIndex(i, EModuleType.IMAGER)
              }}
              checked={moduleType === EModuleType.IMAGER && selectedHotelIndex === i}
              color="alternate"
              label={hotel.display}
              style={{fontSize: '14px'}}
            />
          ))}
        </div>
        </div>
        <div className="store-retrieve-list">
          <div className="title">Storage</div>
        <div className="radio-wrapper">
          {storageHotels.map((hotel, i) => (
            <RadioButton 
              id={hotel.display + "-" + i}
              name={hotel.name}
              onChange={() => setSelectedHotelIndex(i, EModuleType.CHAMBER)}
              checked={moduleType === EModuleType.CHAMBER && selectedHotelIndex === i}
              color="alternate"
              label={hotel.display}
              style={{fontSize: '14px'}}
            />
          ))}
        </div>
        </div>
      </div>
      
    </div>
  );
}
